import React from 'react';
import { Globe2Icon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#140c16] px-5 pb-32 pt-14 text-center sm:pb-28" data-id="element-71" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-4xl" data-id="element-72" data-mp="32nuhkczrziw3">
        <p className="font-display text-3xl font-bold uppercase tracking-wide text-emerald-300" data-id="element-73" data-mp="32p5mig4yiwos">
          PILATES PRONTA™
        </p>
        <p className="mt-3 font-bold text-white" data-id="element-74" data-mp="36nd1b5fv1nxc">
          Il sistema completo per le insegnanti di Pilates.
        </p>
        <p className="mt-2 text-sm italic text-slate-300" data-id="element-75" data-mp="38h5b9u0hiky">
          Perché insegnare Pilates non dovrebbe costarti ogni sera della
          settimana.
        </p>
        <div className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-6 gap-y-3 border-y border-emerald-300/20 py-6 text-sm font-semibold text-slate-300" data-id="element-76" data-mp="3le2fmgombj5f">
          <a className="flex items-center gap-2 hover:text-white" href="mailto:support.peready360@gmail.com" data-id="element-77" data-mp="29y5frxf8retf">
            <MailIcon className="h-4 w-4 text-emerald-300" data-id="element-78" data-mp="2ez1nyn6mln4n" />
            supporto via email
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://instagram.com/peready360" data-id="element-79" data-mp="3la28msb12zu6">
            <InstagramIcon className="h-4 w-4 text-emerald-300" data-id="element-80" data-mp="3gca5t38uhtb7" />
            Seguici su Instagram
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://www.peready360.com" data-id="element-81" data-mp="3v5n6ce92ddy4">
            <Globe2Icon className="h-4 w-4 text-emerald-300" data-id="element-82" data-mp="3qazr75zy9vw7" />
            Sito ufficiale
          </a>
        </div>
        <p className="mt-8 text-[10px] font-bold uppercase tracking-widest text-slate-500" data-id="element-83" data-mp="33xcvurkbsqx">
          PILATES PRONTA™ — Docenti Elite · © 2026 — Tutti i diritti
          riservati.
        </p>
      </div>
    </footer>;
}